import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6859b52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tariff" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "FormBlock" }
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = { class: "FormBlock mt-3" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"FormGrid\" data-v-6859b52a><span data-v-6859b52a></span><span class=\"font-semibold text-sm text-center\" data-v-6859b52a>Грузоподъемность авто</span><span class=\"font-semibold text-sm text-center\" data-v-6859b52a>Зона</span><span class=\"font-semibold text-sm text-center\" data-v-6859b52a>Минималка (часы)</span><span class=\"font-semibold text-sm text-center\" data-v-6859b52a>Тариф за минималку(тг)</span><span class=\"font-semibold text-sm text-center\" data-v-6859b52a>Тариф за +1 доп час (тг)</span></div>", 1)
const _hoisted_8 = { class: "flex items-center font-semibold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_10 = { class: "flex items-center justify-center mt-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_12 = { class: "flex items-center justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Добавление тарифа" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createFtlTariff && _ctx.createFtlTariff(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_select, {
          value: _ctx.state.companyId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.companyId) = $event)),
          placeholder: "Компания",
          loading: _ctx.loading,
          disabled: _ctx.loading,
          options: _ctx.data_state.companies.list,
          failed: _ctx.data_state.companies.is_failed,
          "is-invalid": _ctx.state_form$.companyId.$error,
          "validation-errors": _ctx.state_form$.companyId.$errors,
          "error-text": "При получении списка компаний произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
          onSearch: _ctx.searchCompanies,
          onOptionBySearch: _ctx.unshiftFindedCompany,
          class: "my-3"
        }, null, 8, ["value", "loading", "disabled", "options", "failed", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.loading,
          disabled: _ctx.loading,
          onClick: _ctx.addStandard
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Стандартный тариф ")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tariffs, (tariff, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `tariff-ftl-${i}`,
            class: "FormGrid mt-3"
          }, [
            _createElementVNode("div", _hoisted_8, "Тариф №" + _toDisplayString(i + 1), 1),
            _createVNode(_component_the_select, {
              placeholder: "Выбрать из списка",
              value: tariff.volume,
              "onUpdate:value": ($event: any) => ((tariff.volume) = $event),
              loading: _ctx.loading,
              disabled: _ctx.loading,
              options: _ctx.data_state.ftl_car_types.list,
              failed: _ctx.data_state.ftl_car_types.is_failed,
              "is-invalid": 
                            _ctx.state_form$.tariffs.$each?.$response?.$data[i]?.volume?.$invalid
                        ,
              "error-text": "При получении списка грузоподъемностей произошла ошибка",
              label: "title",
              "search-by": "title",
              "select-by": "value",
              class: "mt-2",
              onRefresh: _ctx.loadFtlCarTypes
            }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "options", "failed", "is-invalid", "onRefresh"]),
            _createVNode(_component_the_select, {
              placeholder: "Выбрать из списка",
              value: tariff.zoneId,
              "onUpdate:value": ($event: any) => ((tariff.zoneId) = $event),
              loading: _ctx.loading,
              disabled: _ctx.loading,
              options: _ctx.data_state.zones.list,
              failed: _ctx.data_state.zones.is_failed,
              "is-invalid": 
                            _ctx.state_form$.tariffs.$each?.$response?.$data[i]?.zoneId?.$invalid
                        ,
              "error-text": "При получении списка зон произошла ошибка",
              label: "description",
              class: "mt-2",
              onRefresh: _ctx.loadZones
            }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "options", "failed", "is-invalid", "onRefresh"]),
            _createVNode(_component_the_input, {
              placeholder: "Введите значение",
              value: tariff.minHour,
              "onUpdate:value": ($event: any) => ((tariff.minHour) = $event),
              disabled: _ctx.loading,
              "is-invalid": 
                            _ctx.state_form$.tariffs.$each?.$response?.$data[i]?.minHour?.$invalid
                        
            }, null, 8, ["value", "onUpdate:value", "disabled", "is-invalid"]),
            _createVNode(_component_the_input, {
              placeholder: "Введите значение",
              value: tariff.price,
              "onUpdate:value": ($event: any) => ((tariff.price) = $event),
              disabled: _ctx.loading
            }, null, 8, ["value", "onUpdate:value", "disabled"]),
            _createVNode(_component_the_input, {
              placeholder: "Введите значение",
              value: tariff.cost,
              "onUpdate:value": ($event: any) => ((tariff.cost) = $event),
              disabled: _ctx.loading,
              "is-invalid": _ctx.state_form$.tariffs.$each?.$response?.$data[i]?.cost?.$invalid
            }, null, 8, ["value", "onUpdate:value", "disabled", "is-invalid"]),
            (i !== 0)
              ? (_openBlock(), _createBlock(_component_the_button, {
                  key: 0,
                  class: "red small text ml-2 py-3",
                  disabled: _ctx.loading,
                  onClick: ($event: any) => (_ctx.deleteTariff(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.addTariff
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_the_button, {
            type: "submit",
            class: "primary small",
            loading: _ctx.loading,
            disabled: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить тариф ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ])
    ], 32)
  ]))
}